function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import _ from "lodash";
var state = {
  controlPoints: [],
  drillingInProgress: false,
  drillSetup: [],
  chosenDrillSetupValues: {},
  stepSize: 250,
  drillSegmentProgress: 0,
  drillSegmentLength: 100,
  currentControlPointMD: null,
  currentFwdLogsJSON: null,
  // is {}
  logPlotData: null,
  // is {}
  logQuantityJSON: [],
  currentMDindex: null,
  currentFwdMDindex: null,
  defaultInstrumentOffset: 0,
  // default 0 meters offset
  currentDrillPosition: {
    Dogleg: {
      tag: "DLG",
      label: "Dogleg:",
      value: ""
    },
    Azimuth: {
      tag: "AZ",
      label: "Azimuth:",
      value: ""
    },
    Inclination: {
      tag: "IN",
      label: "Inclination:",
      value: ""
    },
    MD: {
      tag: "MD",
      label: "MD:",
      value: ""
    }
  },
  lastRequestedLogs: null,
  lastRequestedPointers: null,
  lastSitecomMD: -999999,
  isDrillStep: false,
  plannedLogDataPropertyNeeded: ["MD", "UTMx", "UTMy", "TVDMSL"]
};
var getters = {
  currentControlPoint: function currentControlPoint(state) {
    var temp = state.controlPoints[0];

    if (typeof temp === "undefined") {
      return "";
    } else {
      return temp["title"];
    }
  },
  drillProgressLabel: function drillProgressLabel(state) {
    if (state.drillingInProgress) {
      return "Progress: " + state.drillSegmentProgress + " / " + state.drillSegmentLength + " m";
    } else {
      return "Progress: " + state.drillSegmentProgress + " m";
    }
  } // todo: drillSegmentLength does not react to chosenDrillSetupValues
  // idealy: drillSegmentLength should be in getter not state.
  // drillSegmentLength: state => {
  //   Object.entries(state.chosenDrillSetupValues).forEach(([key, value]) => {
  //     if(key.indexOf("MD") == 0){ // example keys: MD1, MD2, ...
  //       return value;
  //     }
  //   })
  // }

};
var service = {
  parseFwdLogsJSON: function parseFwdLogsJSON(obj) {
    // console.log("parseFwdLogsJSON", obj);
    var property = obj.continuum.property;
    var logPlotData = {};
    property.forEach(function (p) {
      logPlotData[p.name] = {};
      logPlotData[p.name]["d"] = p.d.split(" ").map(Number);
      var instrumentOffset = 0;

      if (p.hasOwnProperty("instrumentOffset")) {
        logPlotData[p.name]["instrumentOffset"] = p.instrumentOffset; // TODO: temp solution for Gina Krog Model only

        switch (p.name) {
          case 'NPHI':
            instrumentOffset = 17.22;
            break;

          case 'RHOB':
            instrumentOffset = 15.13;
            break;

          case 'RT_NEW':
          case 'Resistivity':
            instrumentOffset = 16.98;
            break;

          case 'GR':
            instrumentOffset = 5.16;
            break;

          default:
            instrumentOffset = 0;
        }

        logPlotData[p.name]["instrumentOffset"] = instrumentOffset;
      }

      if (p.hasOwnProperty("description")) logPlotData[p.name]["description"] = p.description;
    });
    return logPlotData;
  }
};
var actions = {
  currentFwdLogsJSONChanged: function currentFwdLogsJSONChanged(_ref, obj) {
    var commit = _ref.commit;

    if (typeof obj != "undefined") {
      commit("updateCurrentFwdLogsJSON", obj);
      commit("updateLogPlotData", service.parseFwdLogsJSON(obj));
      commit("updateLogQuantityJSON", obj.continuum.property);
    }
  }
};
var mutations = {
  updateControlPoints: function updateControlPoints(state, value) {
    if (typeof value === "undefined" || value.length == 0) {
      state.controlPoints = [];
    } else {
      state.controlPoints.unshift(value);
    }
  },
  updateDrillingInProgress: function updateDrillingInProgress(state, value) {
    state.drillingInProgress = value;
  },
  updateDrillSetup: function updateDrillSetup(state, value) {
    if (typeof value === "undefined" || value.length == 0) {
      state.drillSetup = [];
    } else {
      state.drillSetup.push(value);
    }
  },
  updateChosenDrillSetupValues: function updateChosenDrillSetupValues(state, value) {
    if (state.chosenDrillSetupValues != value) {
      state.chosenDrillSetupValues = Object.assign({}, value); // also update drillSegmentLength

      Object.entries(state.chosenDrillSetupValues).forEach(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            key = _ref3[0],
            value = _ref3[1];

        if (key.indexOf("MD") == 0) {
          // example keys: MD1, MD2, ...
          state.drillSegmentLength = value;
          console.log("-----" + key + " = " + value + "------");
        }
      });
    }
  },
  setDrillSegmentLength: function setDrillSegmentLength(state, value) {
    state.drillSegmentLength = value;
  },
  updateStepSize: function updateStepSize(state, value) {
    state.stepSize = parseFloat(value);
  },
  updateDrillSegmentProgress: function updateDrillSegmentProgress(state, value) {
    state.drillSegmentProgress = value;
  },
  updateCurrentControlPointMD: function updateCurrentControlPointMD(state, value) {
    state.currentControlPointMD = value;
  },
  updateCurrentFwdLogsJSON: function updateCurrentFwdLogsJSON(state, value) {
    state.currentFwdLogsJSON = Object.assign({}, value);
  },
  updateLogPlotData: function updateLogPlotData(state, value) {
    state.logPlotData = Object.assign({}, value);
  },
  updateLogQuantityJSON: function updateLogQuantityJSON(state, value) {
    if (_.isEqual(state.logQuantityJSON, value) == false) {
      state.logQuantityJSON = value;
    }
  },
  updateCurrentMDindex: function updateCurrentMDindex(state, value) {
    state.currentMDindex = value; // also update currentDrillPosition

    if (state.logPlotData != null) {
      var currentDLG = state.logPlotData["DLG"].d[value];
      state.currentDrillPosition.Dogleg.value = currentDLG.toFixed(1);
      var currentMD = state.logPlotData["MD"].d[value];
      state.currentDrillPosition.MD.value = currentMD.toFixed(1);
      var currentAZ = state.logPlotData["AZ"].d[value];
      state.currentDrillPosition.Azimuth.value = currentAZ.toFixed(1);
      var currentIN = state.logPlotData["IN"].d[value];
      state.currentDrillPosition.Inclination.value = currentIN.toFixed(1);
    }
  },
  updateCurrentFwdMDindex: function updateCurrentFwdMDindex(state, value) {
    state.currentFwdMDindex = value;
  },
  updateLastRequestedLogs: function updateLastRequestedLogs(state, value) {
    state.lastRequestedLogs = value;
  },
  updateLastRequestedPointers: function updateLastRequestedPointers(state, value) {
    state.lastRequestedPointers = value;
  },
  updateLastSitecomMD: function updateLastSitecomMD(state, value) {
    state.lastSitecomMD = value;
  },
  updateIsDrillStep: function updateIsDrillStep(state, value) {
    state.isDrillStep = value;
  },
  updateDefaultInstrumentOffset: function updateDefaultInstrumentOffset(state, value) {
    state.defaultInstrumentOffset = value;
  }
};
export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};